import {
  type PageContext,
  PageContextContext,
} from '#app/contexts/PageContextContext/PageContextContext.js';
import { useContext } from 'react';

export const usePageContext = (): PageContext => {
  const pageContext = useContext(PageContextContext);

  if (!pageContext) {
    throw new Error(
      '`usePageContext` can not be used outside of `PageContextProvider`.',
    );
  }

  return pageContext;
};
